import { captureMessage } from '@sentry/browser'

export const displayPoints = (points = 0): string => {
  if (isNaN(points)) {
    captureMessage(`Points are not a number`)
    return `0`
  }
  return Number(points).toLocaleString()
}
